import type { AppInstanceSpec } from './schema';
import { appInstanceFromForm } from './spec';

function looksLikeAppInstanceSpec(input: unknown): input is AppInstanceSpec {
  if (!input || typeof input !== 'object') return false;
  const obj = input as Record<string, unknown>;
  return Boolean(obj.headGroupSpec || obj.runtime);
}

/** SKU preset（扁平表单或完整 Spec）规范化后再 parse */
export function normalizeAppInstancePresetToSpec(data: unknown): AppInstanceSpec {
  if (looksLikeAppInstanceSpec(data)) {
    return data;
  }
  const raw = data && typeof data === 'object' ? (data as Record<string, unknown>) : {};
  return appInstanceFromForm(raw, {});
}

export const appInstanceMigrations: Record<number, (data: unknown) => AppInstanceSpec> = {
  1: normalizeAppInstancePresetToSpec,
  2: normalizeAppInstancePresetToSpec,
};
